<template>
    <div v-if="Object.keys(ticketData).length > 0" class="riepilogo-dati-utente-ticket">
        <div class="title">{{ intl[$store.state.lang]["title"]}}</div>
        <div class="lista-dati">
            <div v-for="(infoType, index) in Object.keys(ticketData)"  :key="index" class="text-start">
                <div class="dato-utente" v-if="infoTypes.indexOf(infoType) !== -1 && ticketData[infoType]">
                    <div class="tipo-dato">{{intl[$store.state.lang][infoType]}}</div>
                    <span class="badge rounded-pill bg-secondary">
                        <div :title="ticketData[infoType]" class="valore-dato">{{dataParser(ticketData[infoType],infoType)}}</div>
                    </span>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
import intl from "./intl/intl";
import axios from "axios";
import {apiUrls} from "../../api/apiUrls"
import {formatDate} from '../../api/apiUtils'
export default {
    name: "riepilogoDatiUtenteTicket",
    mounted() {},
    props: {
        
        ticketId: {
            type: Number,
            default: null,
            required: true
        },
        
        setPaginaLoaderCallback: {
            type: Function,
            default: (value) => {console.log("TICKET LOADER: ",value)},
      },
      onGetDataCallback: {
            type: Function,
            default: (response) => {console.log("DATA CALLBACK: ",response)},
        }
        
    },
    created() {
      this.getTicketDetail()
    },
    

    data: function () {
        return {
            intl: intl,
            riepilogoDatiUtenteTicketLoader : false,
            ticketData: {},
            infoTypes: ["first_name","last_name","email","telefon","mobile","job","piva","codfisc","birthplace","birthday"]
        };
    },
    methods: {
        dataParser(data,infoType) {
          
            if(infoType === "birthday"){
                let d = new Date(data)
                return formatDate(d,true)
                
            }else{
                return data
            }
        },

        getTicketDetail() {
            if(this.ticketId){
                this.riepilogoDatiUtenteTicketLoader = true;
                axios.get(apiUrls["ticket_detail"] + this.ticketId)
                    .then((response) => {
                        if(response && response.data){
                            this.ticketData = response.data
                            
                        }
                        this.onGetDataCallback(response)
                        this.riepilogoDatiUtenteTicketLoader = false
                    })
                    .catch((error) => {
                        this.onGetDataCallback(null)
                        this.riepilogoDatiUtenteTicketLoader = false
                    }); 
            }
        }
    },
    watch: {
        riepilogoDomandeRisposteLoader : {
                handler : function(newValue, oldValue) {
                    if(oldValue !== newValue){
                        this.setPaginaLoaderCallback({riepilogoDatiUtenteTicket: newValue})
                    }                
                },
                immediate: true, 
        },
        
    },
    computed: {
        
    },
};
</script>
